import { Injectable } from '@angular/core';
import { AliasEntity, CheckAliasEntity } from '../config/mail-entity.config';
import { EntityManager, IEntity } from '@proximus/entity-manager';
import { Observable } from 'rxjs';

@Injectable()
export class AliasesService {
  constructor() {}

  checkAlias(alias: string, appBrand: string): Observable<IEntity<any>> {
    return EntityManager.getEntity(CheckAliasEntity, { 
      value: alias, 
      appBrand,
    });
  }

  createAlias(mbxId: string, aliasId: string, appBrand: string) {
    return EntityManager.updateEntity(
      EntityManager.createEntity(AliasEntity, { mbxId, aliasId, appBrand }),
    );
  }

  removeAlias(mbxId: string, aliasId: string, appBrand: string) {
    return EntityManager.deleteEntity(
      EntityManager.createEntity(AliasEntity, { mbxId, aliasId, appBrand }),
    );
  }
}
